export function readVibrationPreference(playerId) {
  if (playerId == null) return true;
  try {
    const value = window.localStorage.getItem(`9jawin:whot:vibrate:${String(playerId)}`);
    return value !== 'off';
  } catch (_) { return true; }
}

// buildPrivateClientState() sends myPlayerId and currentPlayerId. Socket payloads can mix ID types.
export function shouldAlertForTurn({ previousTurnId, nextTurnId, playerId, visible, enabled }) {
  return previousTurnId != null && nextTurnId != null && playerId != null
    && String(previousTurnId) !== String(playerId) && String(nextTurnId) === String(playerId)
    && visible === true && enabled === true;
}

export function shouldVibrateForTurn(options) {
  return shouldAlertForTurn(options) && options.supported === true;
}
